import { Box, Container, Grid } from "@mui/material";
import { PreLoader } from "component/pre-loader/pre-loader";
import {  useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./page-not-found.scss";

export const PageNotFound = () => {
  const [pageLoaded, setPageLoaded] = useState<boolean>(false)
  useEffect(() => {
    const timer = setTimeout(() => { setPageLoaded(true) }, 800)
    return () => clearTimeout(timer)
  }, [])
  return (
    <>
      {!pageLoaded ? <PreLoader/> : (<div className="WildCardMain">
        <Box className="page_404" display="flex" alignItems="center" justifyContent="center">
          <Container maxWidth="xl">

            <Grid container spacing={1} display="flex" alignItems="center" justifyContent="center">
              <Grid item md={6} sm={6} xs={12}>
                <div className="">
                  <div className="four_zero_four_bg"></div>
                </div>
              </Grid>

              <Grid item md={6} sm={6} xs={12} display="flex" alignItems="center" justifyContent="center">
                <div className="contant_box_404">
                  <h1>Page Not Found</h1>
                  <h3 className="h2">Look like you're lost</h3>
                  <p>the page you are looking for not available!</p>
                  <Link to="/" className="btn-secondary toHome">
                    {" "}
                    Back to Home
                  </Link>
                </div>
              </Grid>

            </Grid>
          </Container>
        </Box>
      </div>)}
    </>
  );
};
